[
    {
        "author": "James Somers",
        "link": "https://www.newyorker.com/magazine/2018/12/10/the-friendship-that-made-google-huge",
        "note": "A great story on the power of collaboration and a friendship that made Google great.",
        "related_books": [
            {
                "author": "Joshua Wolf Shenk",
                "title": "Powers of Two: Finding the Essence of Innovation in Creative Pairs"
            },
            {
                "author": "Michael Lewis",
                "title": "The Undoing Project: A Friendship That Changed Our Minds"
            }
        ],
        "tags": ["Inspiring", "Programming"],
        "title": "The Friendship That Made Google Huge"
    },
    {
        "author": "Manuel Blum",
        "link": "https://www.cs.cmu.edu/~mblum/research/pdf/grad.html",
        "note": "Most of us won't attend graduate school, but you'll find inspiration here about learning how to learn and how to ask better questions.",
        "tags": ["Inspiring", "Learning"],
        "title": "Advice to a Beginning Graduate Student"
    },
    {
        "author": "Marc Brooker",
        "link": "https://brooker.co.za/blog/2020/01/02/why-distributed.html",
        "note": "Arguments for availability, durability, and scalability.",
        "tags": ["Distributed Systems"],
        "title": "Why do we need distributed systems?"
    },
    {
        "author": "Baxter Holmes",
        "link": "https://www.espn.com/nba/story/_/id/26524600/secret-team-dinners-built-spurs-dynasty",
        "note": "Insights into the Spur's culture and one of the greatest NBA franchises.",
        "tags": ["Culture", "Sports", "Inspiring"],
        "title": "Michelin restaurants and fabulous wines: Inside the secret team dinners that have built the Spurs' dynasty"
    },
    {
        "author": "Stephen Wolfram",
        "link": "https://writings.stephenwolfram.com/2023/02/what-is-chatgpt-doing-and-why-does-it-work/",
        "note": "A fantastic and friendly introduction to the internals of ChatGPT ",
        "tags": ["AI"],
        "title": "What Is ChatGPT Doing ... and Why Does It Work?"
    }
]